// Business constants for The1Autospray
export const BUSINESS = {
  name: "The1Autospray",
  tagline: "Professional Auto Paint & Body Refinishing",
  location: "110 North Sound Rd, Wellys Cool Spot",
  whatsapp: "+1 345-930-6988",
  whatsappRaw: "13459306988",
  email: "the1autospray@gmail.com",
  hours: "Mon–Sat • By Appointment",
  logoUrl:
    "https://customer-assets.emergentagent.com/job_spray-booth-pro/artifacts/l8wk0f1b_1000851966.png",
  social: {
    instagram: "https://www.instagram.com/the1autospray",
    facebook: "https://www.facebook.com/share/1D64ff6zoX/",
    tiktok: "https://www.tiktok.com/@the1autospray",
  },
};

export const whatsappLink = (msg = "Hi, I'd like a quote for my vehicle.") =>
  `https://wa.me/${BUSINESS.whatsappRaw}?text=${encodeURIComponent(msg)}`;

export const SERVICE_TIERS = [
  {
    id: "single-heavy",
    title: "Single-Stage — Heavy Body Work",
    price: "$2,500 – $3,500",
    vehicleType: "SEDANS",
    blurb:
      "Full single-stage repaint for vehicles with multiple dents, scratches, rust spots, and faded paint.",
    image: "https://customer-assets.emergentagent.com/job_24563fa0-1255-473a-97fa-73f99ba3d6a7/artifacts/skx2jn7z_Screenshot_20260509_210721_Chrome.jpg",
    bullets: [
      "10–15 small to medium dents or deep scratches",
      "2–5 rust spots + faded paint correction",
      "Door, trunk, hood jambs available (+$300)",
      "Estimated completion: 3–4 days",
    ],
    eta: "3–4 days",
    accent: "red",
  },
  {
    id: "single-light",
    title: "Single-Stage — Light to Moderate",
    price: "$1,800 – $2,500",
    vehicleType: "HATCHBACK",
    blurb:
      "Affordable single-stage repaint for cars with minor dents, peeling paint, and light fading.",
    image: "https://customer-assets.emergentagent.com/job_24563fa0-1255-473a-97fa-73f99ba3d6a7/artifacts/4qqrozsf_Screenshot_20260509_211954_Chrome.jpg",
    bullets: [
      "Some peeling paint & fading",
      "A few dents and scratches",
      "1–3 small rust spots",
      "Up to 25 labor hours (as fast as 1 day)",
    ],
    eta: "1–2 days",
    accent: "yellow",
  },
  {
    id: "bcc-heavy",
    title: "Basecoat / Clearcoat — Heavy",
    price: "$5,500 – $6,500",
    vehicleType: "VAN",
    blurb:
      "Premium two-stage refinish with deep gloss and durability. Full prep, body work, and rust repair.",
    image: "https://customer-assets.emergentagent.com/job_24563fa0-1255-473a-97fa-73f99ba3d6a7/artifacts/etj35cv4_Screenshot_20260509_221121_Chrome.jpg",
    bullets: [
      "10–15 small/medium dents or deep scratches",
      "2–5 rust spots + faded paint",
      "Custom / classic / body kit: $6,000 – $10,000",
      "7–10 working days (some span 2–4 weeks)",
    ],
    eta: "7–10 days",
    accent: "red",
    featured: true,
  },
  {
    id: "bcc-light",
    title: "Basecoat / Clearcoat — Light",
    price: "$4,500 – $5,500",
    vehicleType: "SUV",
    blurb:
      "Premium full paint with clearcoat protection for vehicles with minor body work needs.",
    image: "https://customer-assets.emergentagent.com/job_24563fa0-1255-473a-97fa-73f99ba3d6a7/artifacts/5wpvqa6d_Screenshot_20260509_214959_Chrome.jpg",
    bullets: [
      "Peeling paint, fading, light dents",
      "1–3 small rust spots",
      "Custom / classic / body kit: $6,000 – $10,000",
      "Up to 40 labor hours",
    ],
    eta: "2–5 days",
    accent: "yellow",
  },
  {
    id: "bcc-truck",
    title: "Basecoat / Clearcoat — Truck",
    price: "$4,000 – $6,500",
    vehicleType: "TRUCK",
    blurb:
      "Premium full paint with clearcoat protection. Choose light or heavy based on your truck's condition.",
    image: "https://customer-assets.emergentagent.com/job_24563fa0-1255-473a-97fa-73f99ba3d6a7/artifacts/fw6kx8zj_Screenshot_20260509_224743_Google.jpg",
    bullets: [
      "Light ($4,000-$4,500): 1-3 rust spots, up to 40 hrs, 2-5 days",
      "Heavy ($5,500-$6,500): 5-10 rust spots, 25-45 hrs, 5-10 days",
      "Peeling paint, fading, light dents",
      "Custom / classic / body kit: $6,000 – $10,000",
    ],
    eta: "2–10 days",
    accent: "yellow",
  },
];

export const TOUCH_UPS = [
  {
    title: "Hood Touch-Up & Refinish",
    examples: [
      { vehicle: "2015 Mercedes Hood", price: "$1,200", note: "Small dent + scratches • 5–8 hrs" },
      { vehicle: "2015 Honda CRV Hood", price: "$550", note: "Prep, paint, refinish" },
    ],
  },
  {
    title: "Fender Touch-Up & Refinish",
    examples: [
      { vehicle: "2015 Mercedes Fender", price: "$600", note: "Small dent + scratches • 2–4 hrs" },
      { vehicle: "2015 Honda CRV Fender", price: "$380", note: "Prep, paint, refinish" },
    ],
  },
];

export const PANEL_PRICING = {
  panels: [
    "Bonnet",
    "Roof",
    "Bumper (ea F/B)",
    "Door (ea)",
    "Fender (ea F/B)",
    "Quarter Panel (ea)",
    "Head Light",
    "Trunk / Tailgate",
  ],
  rows: [
    {
      type: "Standard",
      values: ["$300", "$350", "$275", "$200", "$150", "$175", "$150", "$300"],
      rearLabel: "Trunk",
    },
    {
      type: "SUV",
      values: ["$350", "$400", "$300", "$250", "$175", "$175", "$175", "$350"],
      rearLabel: "Trunk",
    },
    {
      type: "Pick-up Truck",
      values: ["$375", "$350", "$350", "$300", "$200", "$175", "$200", "$250"],
      rearLabel: "Tailgate",
    },
  ],
  footnote:
    "Bumpers, doors, fenders, and quarter panels are priced per panel. Standard cars and SUVs include a trunk; pick-up trucks include a tailgate.",
};

export const MATERIALS = [
  { name: "Paint", desc: "Final color layer — color-matched to spec." },
  { name: "Primer", desc: "Base adhesion layer for a long-lasting bond." },
  { name: "Basecoat", desc: "Color foundation under the clearcoat." },
  { name: "Clearcoat", desc: "Glossy, durable protective top layer." },
  { name: "Masking Tape", desc: "Precision edge protection against overspray." },
  { name: "Masking Paper", desc: "Full-panel overspray shield." },
  { name: "Sandpaper", desc: "Surface preparation and smoothing." },
  { name: "Body Filler", desc: "Dent and damage reshaping compound." },
  { name: "Glaze", desc: "Final surface smoothing before primer." },
  { name: "Hardener", desc: "Curing agent for paint and filler." },
  { name: "Reducer", desc: "Controls paint viscosity for spray quality." },
];

export const GALLERY_IMAGES = [
  {
    url: "https://images.unsplash.com/photo-1761231463972-8006b3d36ef4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHwxfHxzaGlueSUyMHJlZCUyMHNwb3J0cyUyMGNhcnxlbnwwfHx8fDE3Nzc0OTkzODV8MA&ixlib=rb-4.1.0&q=85",
    alt: "Shiny red sports car with spoiler",
    span: "col-span-2 row-span-2",
  },
  {
    url: "https://images.pexels.com/photos/6870314/pexels-photo-6870314.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    alt: "Technician spray painting a car",
    span: "",
  },
  {
    url: "https://images.pexels.com/photos/30250199/pexels-photo-30250199.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    alt: "Technician spray painting a car bumper",
    span: "",
  },
  {
    url: "https://images.pexels.com/photos/33814680/pexels-photo-33814680.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    alt: "White luxury car inside paint booth",
    span: "col-span-2",
  },
  {
    url: "https://images.unsplash.com/photo-1758804027051-40ab1c643485?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHwzfHxzaGlueSUyMHJlZCUyMHNwb3J0cyUyMGNhcnxlbnwwfHx8fDE3Nzc0OTkzODV8MA&ixlib=rb-4.1.0&q=85",
    alt: "Red car fender and headlight close-up",
    span: "",
  },
  {
    url: "https://images.unsplash.com/photo-1765597114288-d8f30bd9b905?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHw0fHxzaGlueSUyMHJlZCUyMHNwb3J0cyUyMGNhcnxlbnwwfHx8fDE3Nzc0OTkzODV8MA&ixlib=rb-4.1.0&q=85",
    alt: "Vintage shiny red sports car",
    span: "",
  },
];

// Real customer work — each PROJECT has stages showing the full journey
export const PROJECTS = [
  {
    id: "toyota-aqua-collision",
    title: "Toyota Aqua — Front-End Collision Restoration",
    service: "Basecoat / Clearcoat • Full Panel Repair",
    tags: ["Collision Repair", "Basecoat/Clearcoat", "Color Match", "Panel Refinish"],
    summary:
      "A full journey from severe front-end collision damage to a showroom-ready finish — documented at every stage. Damage assessment, teardown, body work and prep, then refinished in the booth for a seamless factory-grade color match.",
    stages: [
      {
        id: "damage",
        label: "Stage 1 — Damage Assessment",
        description:
          "The vehicle arrived with heavy front-end collision damage — shattered headlight housing, cracked bumper, and a deep crease in the fender. Every impact point is documented before any work begins.",
        accent: "#E60000",
        images: [
          {
            url: "https://customer-assets.emergentagent.com/job_spray-booth-pro/artifacts/tu42pebv_1000805578.jpg",
            alt: "Smashed headlight and cracked front bumper — pre-repair",
          },
        ],
      },
      {
        id: "teardown",
        label: "Stage 2 — Teardown & Disassembly",
        description:
          "The damaged bumper, grille, and headlight assemblies are carefully removed and laid out for inspection. Salvageable parts are sorted and damaged components marked for replacement.",
        accent: "#FF6A00",
        images: [
          {
            url: "https://customer-assets.emergentagent.com/job_spray-booth-pro/artifacts/u2nrzrn8_1000805784.jpg",
            alt: "Hood open, front end stripped — components laid out on the floor",
          },
        ],
      },
      {
        id: "prep",
        label: "Stage 3 — Body Work & Prep",
        description:
          "Damaged panels are straightened, body filler is applied and sanded, and primer seals the repair area. The vehicle is fully masked in preparation for the spray booth.",
        accent: "#FFCC00",
        images: [
          {
            url: "https://customer-assets.emergentagent.com/job_spray-booth-pro/artifacts/yijt6g9x_1000811523.jpg",
            alt: "Toyota Aqua with basecoat applied — matte finish, awaiting clearcoat",
          },
        ],
      },
      {
        id: "painted",
        label: "Stage 4 — Painted & Refinished",
        description:
          "Basecoat and clearcoat applied in our controlled booth — smooth, even coverage with factory-grade depth and a crisp color match across the repaired panels.",
        accent: "#FFFFFF",
        images: [
          {
            url: "https://customer-assets.emergentagent.com/job_spray-booth-pro/artifacts/c3fkqqs2_1000811516.jpg",
            alt: "Freshly painted Toyota Aqua in the booth — seamless refinish",
          },
        ],
      },
    ],
  },
  {
    id: "suzuki-ciaz-roof",
    title: "Suzuki Ciaz — Roof Refinish",
    service: "Roof Refinish • Basecoat / Clearcoat",
    tags: ["Roof Refinish", "Clearcoat Repair", "Primer & Prep", "Booth Finish"],
    imageMode: "fit",
    summary:
      "Years of sun exposure left the Suzuki Ciaz with heavy clearcoat failure — peeling, blotchy patches across the roof and trunk. Stripped back, primed, masked, and finished with a fresh clearcoat in the booth for a uniform factory-grade shine.",
    stages: [
      {
        id: "before",
        label: "Stage 1 — Before / Damage",
        description:
          "Severe clearcoat failure and sun damage across the roof and trunk — patchy, uneven, and beyond polishing. A full refinish was required.",
        accent: "#E60000",
        images: [
          {
            url: "https://customer-assets.emergentagent.com/job_spray-booth-pro/artifacts/oii3jkoj_1000822716.jpg",
            alt: "Suzuki Ciaz with heavy clearcoat failure — roof and trunk before refinish",
          },
        ],
      },
      {
        id: "primer",
        label: "Stage 2 — Primer Applied",
        description:
          "After sanding back the failed clearcoat, a uniform coat of primer is applied to seal the surface and create the perfect foundation for basecoat adhesion.",
        accent: "#9CA3AF",
        images: [
          {
            url: "https://customer-assets.emergentagent.com/job_spray-booth-pro/artifacts/qdq0m2lc_1000823460.jpg",
            alt: "Suzuki Ciaz with fresh primer applied across the roof and trunk",
          },
        ],
      },
      {
        id: "masking",
        label: "Stage 3 — Masked & Ready for Paint",
        description:
          "Windows, glass, and surrounding panels precisely masked with tape and paper to keep the paint exactly where it belongs — ready to move into the spray booth.",
        accent: "#FFCC00",
        images: [
          {
            url: "https://customer-assets.emergentagent.com/job_spray-booth-pro/artifacts/gead6k5b_1000823757.jpg",
            alt: "Suzuki Ciaz fully masked — rear window and surrounding panels sealed off",
          },
        ],
      },
      {
        id: "painted",
        label: "Stage 4 — Painted & Refinished",
        description:
          "Clearcoat applied over the basecoat — deep, uniform shine with a factory-smooth finish across the entire roof and trunk.",
        accent: "#FFFFFF",
        images: [
          {
            url: "https://customer-assets.emergentagent.com/job_spray-booth-pro/artifacts/axn043lb_1000824910.jpg",
            alt: "Suzuki Ciaz with final clearcoat applied — glossy, factory-grade finish",
          },
        ],
      },
    ],
  },
  {
    id: "mercedes-benz-vito-refinish",
    title: "Mercedes-Benz Vito — Full Body Prep & Paint",
    service: "Body Work • Prep • Single-Stage Refinish",
    tags: ["Body Work", "Primer & Prep", "Masking", "Single-Stage"],
    imageMode: "fit",
    summary:
      "A full body prep and refinish job for the Mercedes-Benz Vito. Dents and imperfections filled and primed across the rear panels, then fully masked and moved into the spray booth for a clean single-stage refinish.",
    stages: [
      {
        id: "prep",
        label: "Stage 1 — Prep & Masking",
        description:
          "Panels are prepped, taped off, and marked out in preparation for spray. Every non-paint surface is sealed with precision tape so the paint lands exactly where it belongs.",
        accent: "#FFCC00",
        images: [
          {
            url: "https://customer-assets.emergentagent.com/job_spray-booth-pro/artifacts/ldjv5rv8_1000800050.jpg",
            alt: "Mercedes-Benz Metris prepped and masked — taped and marked out for spray",
          },
        ],
      },
      {
        id: "painted",
        label: "Stage 2 — Painted & Refinished",
        description:
          "Complete after spray — single-stage refinish applied in the booth for a clean, even, factory-grade finish across the Vito's body panels.",
        accent: "#FFFFFF",
        images: [
          {
            url: "https://customer-assets.emergentagent.com/job_spray-booth-pro/artifacts/49zzyih5_1000800289.jpg",
            alt: "Mercedes-Benz Vito — complete after spray, fresh single-stage refinish",
          },
        ],
      },
    ],
  },
  {
    id: "bmw-full-refinish",
    title: "BMW — Full Hood & Roof Refinish",
    service: "Basecoat / Clearcoat • Full Refinish",
    tags: ["Basecoat/Clearcoat", "Custom Color", "Roof & Hood", "Booth Finish"],
    imageMode: "fit",
    summary:
      "Full refinish on a BMW — every stage documented from prep and masking, through basecoat and clearcoat, to the final deep-blue showroom finish. Precision color match and factory-grade depth.",
    stages: [
      {
        id: "prep",
        label: "Stage 1 — Prep & Masking",
        description:
          "Roof and hood prepped, taped off, and masked with precision paper to protect non-paint surfaces before entering the spray booth.",
        accent: "#FFCC00",
        images: [
          {
            url: "https://customer-assets.emergentagent.com/job_spray-booth-pro/artifacts/abk5nw34_1000867822.jpg",
            alt: "BMW prepped and masked — taped off and ready for spray",
          },
        ],
      },
      {
        id: "basecoat",
        label: "Stage 2 — Basecoat Applied",
        description:
          "Basecoat laid down in smooth, even passes — a rich matte black foundation that locks in the color before clearcoat.",
        accent: "#FF6A00",
        images: [
          {
            url: "https://customer-assets.emergentagent.com/job_spray-booth-pro/artifacts/q0exj9b0_1000862065.jpg",
            alt: "BMW with fresh black basecoat applied — matte finish before clearcoat",
          },
        ],
      },
      {
        id: "painted",
        label: "Stage 3 — Painted & Refinished",
        description:
          "The finished result — deep, glass-smooth reflections, crisp lines, and a factory-grade shine across the entire vehicle.",
        accent: "#FFFFFF",
        images: [
          {
            url: "https://customer-assets.emergentagent.com/job_spray-booth-pro/artifacts/xvj9l9uv_1000862070.jpg",
            alt: "BMW — final deep-blue refinish with factory-grade shine",
          },
        ],
      },
      {
        id: "clearcoat",
        label: "Stage 4 — Clearcoat Applied",
        description:
          "Clearcoat laid over the basecoat to seal in the color, lock in depth, and protect the finish with a glossy durable top layer.",
        accent: "#9CA3AF",
        images: [
          {
            url: "https://customer-assets.emergentagent.com/job_spray-booth-pro/artifacts/t9x08gz0_1000861980.jpg",
            alt: "BMW after clearcoat — smooth glossy top layer sealing the basecoat",
          },
        ],
      },
    ],
  },
];

// Home-page preview uses the first project's first & last photos as before/after
export const BEFORE_AFTER_PROJECTS = [
  {
    id: "toyota-aqua",
    title: "Toyota Aqua — Front-End Restoration",
    services: ["Basecoat / Clearcoat", "Panel Repair", "Color Match"],
    before:
      "https://customer-assets.emergentagent.com/job_spray-booth-pro/artifacts/tu42pebv_1000805578.jpg",
    after:
      "https://customer-assets.emergentagent.com/job_spray-booth-pro/artifacts/c3fkqqs2_1000811516.jpg",
    summary:
      "Heavy front-end collision damage restored to factory-grade finish. Full basecoat / clearcoat refinish with precision color match.",
  },
];

export const SHOP_WORK_IMAGES = [
  {
    url: "https://customer-assets.emergentagent.com/job_spray-booth-pro/artifacts/u2nrzrn8_1000805784.jpg",
    alt: "Teardown stage — front end stripped",
    label: "Teardown & Disassembly",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_spray-booth-pro/artifacts/yijt6g9x_1000811523.jpg",
    alt: "Toyota Aqua with basecoat applied — matte finish, awaiting clearcoat",
    label: "Body Work & Prep",
  },
];

export const FEATURED_PROJECTS = [];

export const HERO_IMAGE =
  "https://images.unsplash.com/photo-1761231463972-8006b3d36ef4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHwxfHxzaGlueSUyMHJlZCUyMHNwb3J0cyUyMGNhcnxlbnwwfHx8fDE3Nzc0OTkzODV8MA&ixlib=rb-4.1.0&q=85";

export const PROCESS_IMAGE =
  "https://images.pexels.com/photos/6870314/pexels-photo-6870314.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";
